<template>
	<div id="portability-page">

		<section class="container content-section">
			<div class="row">
				<div class="col-12 col-title-s1">
					<h3 class="title">Portabilidad</h3>
				</div>

				<div class="col-12 col-tabs">
					<div id="portabilidad-tabs" class="row justify-content-center">
						<router-link 
							class="box-tab" 
							:class="{ active: ($route.path.endsWith('enviado') || $route.path == ('portabilidad')) }" 
							to="/portabilidad">
							<div>Portabilidad</div>
						</router-link>
						<router-link class="box-tab" to="/portabilidad/que-es">
							<div>¿Qué es?</div>
						</router-link>
						<router-link class="box-tab" to="/portabilidad/pasos-para-la-portabilidad">
							<div>Pasos para la <span class="d-sm-block">Portabilidad</span></div>
						</router-link>
						<!-- <router-link class="box-tab" to="/preguntas-frecuentes">
								<div>Preguntas frecuentes</div>
							</router-link> -->
					</div>
				</div>

				<router-view></router-view>

			</div>
		</section>

	</div>
</template>

<script>
export default {
	data() {
		return {}
	},

	methods: {}
}
</script>
